import { VendorRebateCategoryPermissions } from '../../../components/Vendor/RebateCategories';

export function RebateCategoryPermissions() {
  return <VendorRebateCategoryPermissions />;
}
